<p-card header="Gross Report">
  <div class="grid">
    <div class="col-3">
      <label htmlFor="" style="font-size: large; font-weight: bold"
        >Select Date:
      </label>
      <p-calendar
        [(ngModel)]="date"
        [showIcon]="true"
        class=""
        (onSelect)="LoadGross()"
      ></p-calendar>
    </div>
    <div class="col-3">
      <label htmlFor="code" style="font-size: large; font-weight: bold"
        >Select Time:
      </label>
      <p-dropdown
        [style]="{ width: '80%' }"
        optionLabel="value"
        optionValue="value"
        [options]="drawtime"
        [(ngModel)]="selecteddrawtime"
        (onChange)="LoadGross()"
      ></p-dropdown>
    </div>
    <div class="col-3">
      <label htmlFor="" style="font-size: large; font-weight: bold"
        >Select Group:
      </label>
      <!-- <h6>DRAW TIME :</h6> -->
      <p-dropdown
        [style]="{ width: '80%' }"
        optionLabel="value"
        optionValue="value"
        [options]="coor"
        [showClear]="true"
        placeholder="Select Group"
        [(ngModel)]="selectedcoor"
        (onChange)="LoadGross()"
      ></p-dropdown>
    </div>
    <div class="col-3">
      <label htmlFor="" style="font-size: large; font-weight: bold"
        >Select Area:
      </label>
      <!-- <h6>DRAW TIME :</h6> -->
      <p-dropdown
        [style]="{ width: '80%' }"
        optionLabel="value"
        optionValue="value"
        [options]="location"
        [showClear]="true"
        placeholder="Area Code"
        [(ngModel)]="selectedlocation"
        (onChange)="LoadGross()"
      ></p-dropdown>
    </div>
  </div>

  <!-- <p-button label="Load" class="ml-3" (onClick)="LoadGross()"></p-button> -->
  <div class="card mt-4">
    <p-table
      #dt
      [value]="grossbets?.length ? grossbets : null"
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="10"
    >
      <ng-template pTemplate="caption">
        <div class="flex">
          <button
            type="button"
            pButton
            pRipple
            icon="pi pi-file-excel"
            (click)="exportExcel()"
            class="p-button-success mr-2"
            pTooltip="XLS"
            tooltipPosition="bottom"
          ></button>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>Date</th>
          <th>Agent</th>
          <th>Total Gross</th>
          <th>Total Hits</th>
          <th>Net Total</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-gross>
        <tr>
          <td>{{ gross.Date }}</td>
          <td>{{ gross.agent }}</td>
          <td>{{ gross.TotalGross }}</td>
          <td>{{ gross.TotalHits }}</td>
          <td>{{ gross.NetTotal }}</td>
          <!-- <td>
              <p-button
                class="mx-1"
                icon="pi pi-user-edit"
                styleClass="p-button-rounded p-button-warning"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                styleClass="p-button-rounded p-button-danger"
              ></p-button>
            </td> -->
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="5">No data found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>

<p-dialog header="ADD" [(visible)]="visible" [style]="{ width: '50vw' }">
  <div class="grid">
    <div class="col-6">
      <div class="flex flex-column gap-2">
        <label htmlFor="code">Code</label>
        <input
          pInputText
          id="code"
          aria-describedby="code-help"
          [(ngModel)]="Code"
        />
      </div>
    </div>
    <div class="col-6">
      <div class="flex flex-column gap-2">
        <label htmlFor="name">Name</label>
        <input
          pInputText
          id="name"
          aria-describedby="name-help"
          [(ngModel)]="Name"
        />
      </div>
    </div>
    <!-- <div class="col-4">
          <div class="flex flex-column gap-2">
            <label htmlFor="">Lastname</label>
            <input
              pInputText
              id="lastname"
              aria-describedby="username-help"
              [(ngModel)]="value"
            />
          </div>
        </div> -->
  </div>
  <div class="flex flex-row-reverse flex-wrap">
    <button
      pButton
      pRipple
      label="SAVE"
      class="p-button-info mt-3 ml-2"
    ></button>
  </div>
</p-dialog>
